import axios from 'axios'

export const state = {
  notifications: null,
}

export const getters = {
  notifications: (state) => state.notifications,
}

export const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },
}

export const actions = {
  fetchAllNotifications({ commit }) {
    return axios.get('/api/notifications').then((response) => {
      const notifications = response.data
      commit('SET_NOTIFICATIONS', notifications)
      return notifications
    })
  },

  deleteNotification(_, id) {
    return axios.delete(`/api/notifications/${id}`)
  },
}
